import React, { useEffect, useState } from 'react';
import { BellOutlined } from '@ant-design/icons';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseBadge } from '@app/components/common/BaseBadge/BaseBadge';
import { NotificationsOverlay } from '@app/components/header/components/notificationsDropdown/NotificationsOverlay/NotificationsOverlay';
import { HeaderActionWrapper } from '@app/components/header/Header.styles';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';
import { useMounted } from '@app/hooks/useMounted';
import {
  deleteNotification,
  getLatestNotifications,
  markNotificationAsRead,
  NotificationResponse,
} from '@app/api/notificationCenter.api';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { readToken } from '@app/services/localStorage.service';

import { setUnreadUpdateHandler, resetUnreadCount } from '@app/hooks/useSSE';
import { getLatestNotificationsRabbit, markRabbitNotificationAsRead } from '@app/api/notificationRabbit.api';
declare global {
  interface Window {
    __updateUnreadFromBell?: (delta: number) => void;
  }
    interface Window {
    __refreshNotificationDropdown?: () => void;
  }
}

export const NotificationsDropdown: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpened, setOpened] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0); // 👈 新增未读状态
  const { isMounted } = useMounted();
  const { t } = useTranslation();

  useEffect(() => {
//  fetchLatestNofications();

  setUnreadUpdateHandler((count) => {
    setUnreadCount(count);

    window.__updateUnreadFromBell = (delta: number) => {
      setUnreadCount((prev) => Math.max(0, prev + delta));
    };
  });

    // ✅ Register dropdown refresh hook
  window.__refreshNotificationDropdown = () => {
    //fetchLatestNofications();
  };

  return () => {
    delete window.__refreshNotificationDropdown;
  };
}, [isMounted]);


  const fetchLatestNofications = async () => {
    setIsLoading(true);
    try {
      const response = await getLatestNotificationsRabbit();
      if (isMounted.current && response) {
       
        setNotifications(response);

          const unreadRes = await fetch(`${process.env.REACT_APP_BASE_URL}/sse/UnreadCount/Check?areaCode=${process.env.REACT_APP_CURRENT_LOCALITY}`);
          const unreadJson = await unreadRes.json();
          const unreadCount = unreadJson.data.count ?? 0;
          setUnreadCount(unreadCount);
        
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

const markAsRead = async (id: number) => {
  try {
    const response = await markRabbitNotificationAsRead(id);
    if (isMounted.current && response) {

      setNotifications((prev) => prev.filter((item) => item.id !== id));
        window.__refreshNotificationDropdown?.();
        window.__refreshUnreadCount?.(); 
        window.__refreshNotificationList?.();
    }
  } catch (error) {
    console.error(error);
  }
};

  const remove = async (id: number) => {
    try {
      const response = await deleteNotification(id);
      if (isMounted.current && response) {
        await fetchLatestNofications();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <BasePopover
        trigger="click"
        content={
          isLoading ? (
            <Spin spinning={isLoading} tip={t('common.loading')} />
          ) : (
            <NotificationsOverlay
              notifications={notifications}
              setNotifications={setNotifications}
              markAsRead={markAsRead}
              removeNotification={remove}
            />
          )
        }
        onOpenChange={(open) => {
          setOpened(open);
          // if (open) {
          //   resetUnreadCount();
          // }
        }}
      >
        <HeaderActionWrapper>
          <BaseButton
            type={isOpened ? 'ghost' : 'text'}
            icon={
              <BaseBadge count={unreadCount} overflowCount={99}>
                <BellOutlined />
              </BaseBadge>
            }
          />
        </HeaderActionWrapper>
      </BasePopover>
    </>
  );
};
